<template>
  <div class="bg-white py-12 sm:py-6" id="faqs-top">
    <div class="mx-auto max-w-5xl px-6">
      <div class="mx-auto max-w-xl text-center">
        <h2 class="text-2xl font-bold">FAQs</h2>
      </div>
      <dl class="mt-4 space-y-6 divide-y divide-gray-900/10">
        <Disclosure as="div" v-for="faq in faqs" :key="faq.question" class="pt-6" v-slot="{ open }">
          <dt>
            <DisclosureButton class="flex w-full items-start justify-between text-left text-gray-900">
              <span class="text-base font-semibold leading-7">{{ faq.question }}</span>
              <span class="ml-6 flex h-7 items-center">
                <PlusSmallIcon v-if="!open" class="h-6 w-6" aria-hidden="true" />
                <MinusSmallIcon v-else class="h-6 w-6" aria-hidden="true" />
              </span>
            </DisclosureButton>
          </dt>
          <DisclosurePanel as="dd" class="mt-2 pr-12">
            <p class="text-base leading-7 text-gray-600">{{ faq.answer }}</p>
          </DisclosurePanel>
        </Disclosure>
      </dl>
    </div>
  </div>
</template>

<script setup>
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import { MinusSmallIcon, PlusSmallIcon } from '@heroicons/vue/24/outline'

const faqs = [
  {
    question: 'What is PS Kids All Day Prayer?',
    answer: 'PS Kids All Day Prayer is a dedicated prayer event for children and youth as part of the Prayer Storm movement. It brings kids together for focused prayer, worship, and seeking God throughout the day.'
  },
  {
    question: 'Who is the event for?',
    answer: 'This event is designed for children and young people, typically around 7-16 years old.'
  },
  {
    question: 'Where is the event held?',
    answer: 'Online stream via PrayerStormTV, and in-person attendance at Bethany Church, 100 Church Road, Gatley, Stockport, SK8 4NQ. Tickets are required for in-person attendance.'
  },
  {
    question: 'Do I need to register or buy a ticket?',
    answer: 'Yes. In-person participation requires registration or a ticket through Prayer Storm\'s website.'
  },
  {
    question: 'What happens during the All Day Prayer?',
    answer: 'During the event, kids gather to pray, worship, and intercede together, growing in their prayer life and spiritual connection.'
  },
  {
    question: 'Do parents or adults need to accompany children?',
    answer: 'For All Day Prayer, parents or guardians need to accompany their children.'
  },
  {
    question: 'Can siblings or friends attend together?',
    answer: 'Yes! Children and youth are welcome to attend with siblings and friends, as long as they are within the age range and have a guardian with them at all times.'
  },
  {
    question: 'Is there a space for children with special needs?',
    answer: 'Usually, we aim to provide this and be inclusive and accommodating. However, due to other bookings and venue limitations, this time it has not been possible.'
  }
]
</script>
